
<template>
  <div class="wxseparation">
      <div v-show="conte_show" class="wxseparation_content" v-html="conte"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        conte:'',
        conte_show:false,
      }
    },
    created() {
      document.title='斐燃会员使用规则'
    },
    activated() { },
    watch: { },
    mounted() {
      this.getViperSecret()
    },
    methods: {
      getViperSecret(){
        var $this = this
        this.$loading('加载中');
        let param = {}
        var qs = require('qs');
        let url = this.api.userApi.wxseparation_vipUsageAgreement
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code==200) {
            $this.$loading.close()
            $this.conte=result.data
            $this.conte_show=true
          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .wxseparation{
    width: 100%;
    padding: 40*@vm_base;
    .wxseparation_content{
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0*@vm_base 4*@vm_base 20*@vm_base 0*@vm_base #EEEEEE;
      border-radius: 12*@vm_base;
      padding: 40*@vm_base 30*@vm_base;
      font-size: 28*@vm_base;
      font-weight: 400;
      color: #333333;
      line-height: 1.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/wxseparation/wxviprule.vue